import styled from 'styled-components';

export const Loading = styled.div`
  z-index: 999;
  background-color: #000;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: absolute;
  opacity: 0.5;
`;

export const Texto = styled.h4`
  font-size: 20px;
  color: #fff;
`;

export const DivLoading = styled.div`
  margin: auto;
  top: 25vh;
  width: 100%;
  text-align: center;
  z-index: 1000;
  font-size: 160px;
  position: fixed;
  color: #fff;
`;
